import React, { memo, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { Badge } from '@material-ui/core'

import { EditRounded as EditIcon } from '@material-ui/icons'

import DialogEditName from '../../organisms/dialogs/editName'
import Avatar from '../../atoms/display/avatar'
import Typography from '../../atoms/display/typography'
import IconButton from '../../atoms/inputs/iconButton'

import useStyles from './customerStyle'

const Consumer = (props) => {
  const StyledBadge = withStyles((theme) => ({
    badge: {
      backgroundColor: theme.palette.status[props.status],
      color: '#fff',
      borderRadius: '50%',
    },
  }))(Badge)

  const classes = useStyles()
  const { t } = useTranslation()
  const [dialogEditName, setDialogEditName] = useState(false)
  const [firstName, setFirstName] = useState()
  const [lastName, setLastName] = useState()
  const conversation = useSelector(
    (state) => state.conversations.conversations[props.conversationId]
  )
  const activeConversation = useSelector((state) => state.activeConversation)

  useEffect(() => {
    const name = conversation?.consumer?.displayName
      ? conversation?.consumer?.displayName
      : conversation?.consumer?.name
    setFirstName(name?.split(' ')[0])
    setLastName(name?.split(' ')[1])
  }, [conversation])

  const renderVariants = () => {
    if (props.variant) {
      return (
        <>
          <div style={{ marginLeft: 10 }}>
            <Typography variant="body1" style={{ marginTop: 5 }}>
              {conversation?.consumer?.displayName
                ? conversation?.consumer?.displayName +
                  ` (${t('commons.edited')})`
                : conversation?.consumer?.name}
            </Typography>
            <Typography variant="body2" style={{ marginTop: 0 }}>
              {props.text}
            </Typography>
            <Typography style={{ fontSize: '12px', cursor: 'text' }}>
              <span className="escapeDragScroll">
                {`${t('fields.protocol.label')} : ${conversation?.protocol}`}
              </span>
            </Typography>
          </div>
        </>
      )
    }
  }

  return (
    <>
      <div
        style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        <StyledBadge
          overlap="circle"
          variant={props.newMessages ? 'standard' : 'dot'}
          badgeContent={props.newMessages}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <div
            className={
              props.conversationId === activeConversation
                ? classes.rootAvatarEditable
                : classes.rootAvatar
            }
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <Avatar
                src={props.user?.url_avatar ? props.user?.url_avatar : ''}
              >
                {firstName?.charAt(0).toUpperCase()}
                {lastName?.charAt(0).toUpperCase()}
              </Avatar>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation()
                  setDialogEditName(true)
                }}
                color="primary"
              >
                <EditIcon style={{ color: '#fff' }} />
              </IconButton>
            </div>
          </div>
        </StyledBadge>
        {renderVariants()}
      </div>
      {dialogEditName && (
        <DialogEditName
          dialogOpen={dialogEditName}
          setDialogOpen={setDialogEditName}
        />
      )}
    </>
  )
}

export default memo(Consumer)
